import {MeterReadingDTOModel} from './meter-reading-DTO.model';
import {DetaillineDTOModel} from './detaillineDTO.model';

export class WsTaskDTOModel {
    public nsuk: number;
    public option: number;
    public description: string;
    public meterReadings: MeterReadingDTOModel[];
    public sparesUsed: DetaillineDTOModel[];

    [x: string]: any;
}
